import { render, staticRenderFns } from "./IntegrationOption.vue?vue&type=template&id=8f15f766&scoped=true"
import script from "./IntegrationOption.vue?vue&type=script&lang=js"
export * from "./IntegrationOption.vue?vue&type=script&lang=js"
import style0 from "./IntegrationOption.vue?vue&type=style&index=0&id=8f15f766&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f15f766",
  null
  
)

export default component.exports